import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Gamepad from '../../GamePad';
import Ps5Layout from '../../GamePad/layouts/PS5';

import ArrowsBackground from '../Ps5Share/ArrowsBackground';
import ArrowsBorder from '../Ps5Share/ArrowsBorder';
import Body from '../Ps5Share/Body';
import DownArrow from '../Ps5Share/DownArrow';
import L1Button from '../Ps5Share/L1Button';
import L2Button from '../Ps5Share/L2Button';
import LeftArrow from '../Ps5Share/LeftArrow';
import LeftStick from '../Ps5Share/LeftStick';
import LeftStickBorder from '../Ps5Share/LeftStickBorder';
import OButton from '../Ps5Share/OButton';
import OptionsButton from '../Ps5Share/OptionsButton';
import PsButton from '../Ps5Share/PsButton';
import R1Button from '../Ps5Share/R1Button';
import R2Button from '../Ps5Share/R2Button';
import RightArrow from '../Ps5Share/RightArrow';
import RightStick from '../Ps5Share/RightStick';
import RightStickBorder from '../Ps5Share/RightStickBorder';
import Speaker from '../Ps5Share/Speaker';
import SquareButton from '../Ps5Share/SquareButton';
import SticksBackground from '../Ps5Share/SticksBackground';
import TouchPad from '../Ps5Share/TouchPad';
import TriangleButton from '../Ps5Share/TriangleButton';
import UpArrow from '../Ps5Share/UpArrow';
import XButton from '../Ps5Share/XButton';

import Logo from './components/Logo';
import ShareButton from './components/ShareButton';

const STICK_OFFSET = 30;

function ControllerPs5Gbest({ data, styles }) {
  const [gamepad, setGamepad] = useState({
    ...Ps5Layout.buttonsDefault,
    ...Ps5Layout.axisDefault,
  });
  const { player } = data;

  const axisChangeHandler = (axisName, value) => {
    setGamepad((prevState) => ({ ...prevState, [axisName]: value }));
  };
  const buttonChangeHandler = (buttonName, value) => {
    setGamepad((prevState) => ({ ...prevState, [buttonName]: value }));
  };

  return (
    <>
      <Gamepad
        gamepadIndex={player}
        layout={Ps5Layout}
        onButtonChange={buttonChangeHandler}
        onAxisChange={axisChangeHandler}
      >
        <svg
          width="800"
          height="600"
          viewBox="0 0 800 600"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <R2Button
            activeColor={styles.active.color}
            color="#368ABD"
            value={gamepad.RightTrigger}
          />
          <R1Button
            active={gamepad.R1}
            activeColor={styles.active.color}
            color="#368ABD"
          />
          <L1Button
            active={gamepad.L1}
            activeColor={styles.active.color}
            color="#E5152D"
          />
          <L2Button
            activeColor={styles.active.color}
            color="#E5152D"
            value={gamepad.LeftTrigger}
          />
          <Body background={styles.body.background} color={styles.body.color} />
          <SticksBackground color={styles.sticks.background} />
          <g
            style={{
              transform: `translateX(${
                gamepad.LeftStickX * STICK_OFFSET
              }px) translateY(${-gamepad.LeftStickY * STICK_OFFSET}px)`,
            }}
          >
            <LeftStickBorder
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <LeftStick
              active={gamepad.L3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <g
            style={{
              transform: `translateX(${
                gamepad.RightStickX * STICK_OFFSET
              }px) translateY(${-gamepad.RightStickY * STICK_OFFSET}px)`,
            }}
          >
            <RightStickBorder
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.border}
            />
            <RightStick
              active={gamepad.R3}
              activeColor={styles.active.color}
              color={styles.sticks.color}
            />
          </g>
          <TriangleButton
            active={gamepad.Triangle}
            activeColor={styles.active.color}
            background={styles.buttons.background}
            border={styles.buttons.border}
            color={styles.buttons.color}
          />
          <OButton
            active={gamepad.O}
            activeColor={styles.active.color}
            background={styles.buttons.background}
            border={styles.buttons.border}
            color={styles.buttons.color}
          />
          <XButton
            active={gamepad.X}
            activeColor={styles.active.color}
            background={styles.buttons.background}
            border={styles.buttons.border}
            color={styles.buttons.color}
          />
          <SquareButton
            active={gamepad.Square}
            activeColor={styles.active.color}
            background={styles.buttons.background}
            border={styles.buttons.border}
            color={styles.buttons.color}
          />
          <UpArrow
            active={gamepad.UpArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <RightArrow
            active={gamepad.RightArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <LeftArrow
            active={gamepad.LeftArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <DownArrow
            active={gamepad.DownArrow}
            activeColor={styles.active.color}
            color={styles.arrows.color}
          />
          <ArrowsBorder color={styles.arrows.border} />
          <PsButton
            active={gamepad.Ps}
            activeColor={styles.active.color}
            border={styles.ps.border}
            color={styles.ps.background}
          />
          <Speaker />
          <TouchPad
            active={gamepad.TouchPad}
            activeColor={styles.active.color}
            border={styles.touchpad.border}
            color={styles.touchpad.background}
          />
          <OptionsButton
            active={gamepad.Options}
            activeColor={styles.active.color}
            border="#368ABD"
            color={styles.options.color}
          />
          <ShareButton
            active={gamepad.Share}
            activeColor={styles.active.color}
            border={styles.options.border}
            color={styles.options.color}
          />
          <ArrowsBackground color={styles.arrows.border} />
          <Logo />
        </svg>
      </Gamepad>
    </>
  );
}

ControllerPs5Gbest.propTypes = {
  data: PropTypes.shape({
    player: PropTypes.number,
  }),
  styles: PropTypes.shape({
    active: PropTypes.shape({
      color: PropTypes.string,
    }),
    arrows: PropTypes.shape({
      color: PropTypes.string,
      border: PropTypes.string,
    }),
    body: PropTypes.shape({
      background: PropTypes.string,
      color: PropTypes.string,
    }),
    buttons: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    options: PropTypes.shape({
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    ps: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
    }),
    sticks: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
    }),
    touchpad: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
    }),
  }),
};

ControllerPs5Gbest.defaultProps = {
  data: {
    player: 0,
  },
  styles: {
    active: {
      color: '#E2BA2A',
    },
    arrows: {
      color: '#D7DEE6',
      border: '#E5152D',
    },
    body: {
      background: '#191D26',
      color: '#111111',
    },
    buttons: {
      background: '#D7DEE6',
      border: '#368ABD',
      color: '#368ABD',
    },
    options: {
      border: '#919191',
      color: '#DEE2EB',
    },
    ps: {
      background: '#1A1B20',
      border: '#FFFFFF',
    },
    sticks: {
      background: '#20232E',
      border: '#2A2F35',
      color: '#1F2227',
    },
    touchpad: {
      background: '#1E1E1E',
      border: '#0063FA',
    },
  },
};

export default ControllerPs5Gbest;
